
import Vue from 'vue';
import { Vue as VueBase, Component } from 'vue-property-decorator';
import {
  CreateShipmentValidationState,
} from '@/features/shipment/helpers/createShipmentValidation';

@Component({
  provide(): {
    isEstimatePage: boolean;
    createShipmentValidationState: CreateShipmentValidationState;
    } {
    return {
      isEstimatePage: true,
      createShipmentValidationState: (this as any).createShipmentValidationState,
    };
  },
})
export default class Estimate extends VueBase {
  private createShipmentValidationState = Vue.observable<CreateShipmentValidationState>({
    attempted: false,
  });

  destroyed(): void {
    this.createShipmentValidationState.attempted = false;
  }
}
